import { Type } from "class-transformer";
export class DateIntv {
    @Type(() => Date)
    start: Date;
    @Type(() => Date)
    end: Date;
}
